"use strict"; //任何一个工具类加上这个
import Vue from 'vue'
import store from '../store'

if (!Function.prototype.bind) {
  Function.prototype.bind = function () {
    var fn = this,
      args = Array.prototype.slice.call(arguments),
      object = args.shift();
    return function () {
      return fn.apply(object, args.concat(Array.prototype.slice.call(arguments)));
    }
  }
}
const util = {
  // Host: "http://192.168.102.94:9092/hospital/",
  // Host: "http://dev-platform.ifarmiot.com/hospital/",

  // Host: "http://192.168.102.94:9092/hospital/",

  // Host: "http://192.168.102.73:9092/hospital/",

  // Host: "http://192.168.102.19:9092/hospital/",
  // Host: "http://192.168.102.232:9092/hospital/",


  Host: "http://api.hostpital.test.ilejian.com/hospital/",

  WebsiteTitle: "药师业务系统",
  copyrightName: "乐荐云医",
  // icp_number: "[ICP备]",

  copyrightFullName: "银川乐荐互联网医院",
  icp_number: "[ICP备200号]",


  /**
       * 获取签名 将链接地址的所有参数按字母排序后拼接加上token进行md5
       * url 链接地址
       * date 参数{参数名1 : 值1, 参数名2 : 值2} *
       * token 签名token 非必须
       */
  getAccessToken: function () {
    // return md5('www.eciyuan.net' + 'l2V|gfZp{8`;jzR~6Y1_');
    // return 'www.eciyuan.net' + 'l2V|gfZp{8`;jzR~6Y1_';
  },

  /*
   ** randomWord 产生任意长度随机字母数字组合
   ** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
   ** xuanfeng 2014-08-28
   */
  randomWord: function (randomFlag, min, max) {
    var str = "",
      range = min,
      arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
        'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
        'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
      ];

    // 随机产生
    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min;
    }
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  },

  /**
   * 签名 SHA1(AppSecret + Nonce)，
   * 三个参数拼接的字符串，进行SHA1哈希计算，转化成16进制字符(String，小写)
   */
  getSign: function () {
    var sha1_result = hex_sha1('a060e77c5a8485aeb061aee5d7f8fa709acb4473' + '123456');
    console.log('sha1_result:', sha1_result);
    return (sha1_result.toString(16)).toLowerCase();
  },

  /**
   * 用户userToken
   * @returns {undefined}
   */
  getUserToken: function () {
    return util.getStore('user_token');
  },

  /**
   * 存储localStorage
   */
  setStore: function (name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
  },

  /**
   * 获取localStorage
   */
  getStore: function (name) {
    if (!name) return;
    return window.localStorage.getItem(name);
  },

  /**
   * 删除localStorage
   */
  removeStore: function (name) {
    if (!name) return;
    window.localStorage.removeItem(name);
  },

  /**
   * 清除缓存
   */
  clearStorage: function () {
    window.localStorage.clear();
  },

  /**
   * 参数处理
   * @param data
   * @returns {string}
   */
  paramHandle: function (data) {
    var result_json = '';
    var newJson = '';
    var user_token = this.getStore('user_token');
    if (user_token !== "" && user_token !== null && user_token !== undefined && user_token !== "undefined") {
      newJson = {
        token: user_token
      };
    }
    if (data !== '' && newJson !== '') {
      result_json = this.mergeJsonObject(data, newJson);
    } else if (newJson === '') {
      result_json = data;
    } else if (data === '') {
      result_json = newJson;
    }
    return result_json;
  },

  /**
   * json 合并
   * @param jsonbject1
   * @param jsonbject2
   * @returns {{}}
   */
  mergeJsonObject: function (jsonbject1, jsonbject2) {
    var resultJsonObject = {};
    for (var attr in jsonbject1) {
      resultJsonObject[attr] = jsonbject1[attr];
    }
    for (var attr in jsonbject2) {
      resultJsonObject[attr] = jsonbject2[attr];
    }
    return resultJsonObject;
  },

  url: function (action, querystring) {
    var url = action;
    if (querystring && typeof querystring === 'object') {
      for (var param in querystring) {
        if (param && querystring.hasOwnProperty(params) && querystring[param]) {
          url += param + '=' + querystring[param] + '&';
        }
      }
    }
    return url;
  },
  /**
   * 将以base64的图片url数据转换为Blob
   * @param urlData
   *            用url方式表示的base64图片数据
   *             var img = "data:image/jpeg;base64," + imageData;
   */
  convertBase64UrlToBlob: function (urlData) {

    var arr = urlData.split(',');
    var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
    //处理异常,将ascii码小于0的转换为大于0
    var mime = arr[0].match(/:(.*?);/)[1];
    var ab = new ArrayBuffer(bytes.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
      type: mime
    });
  },
  /*
  * 图片的绝对路径地址 转换成base64编码 如下代码：
    var image = new Image();
    image.crossOrigin = '';
    image.src = img;
    image.onload = function () {
      var base64 = getBase64Image(image);
      console.log(base64);
    }
  */
  getBase64Image: function (img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, img.width, img.height);
    var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
    var dataURL = canvas.toDataURL("image/" + ext);
    return dataURL;
  },
  //**dataURL to blob**
  dataURLtoBlob: function (dataurl) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  },

  /**
   * data:[<mime type>][;charset=<charset>][;base64],<encoded data>
   * * base64  to blob二进制
   */
  dataURItoBlob: function (base64Data) {
    var byteString;
    if (base64Data.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(base64Data.split(',')[1]);
    else
      byteString = unescape(base64Data.split(',')[1]);
    var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {
      type: mimeString
    });
  },
  /**
   * @desc 地址参数获取
   * @auth Vman
   * */
  GetQueryString: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  /**
   * 
   * @param {*} url 文件地址不可含有域名
   * @param {*} callback 成功回调函数
   */
  fileUrlHandle: function (url, callback) {
    var fileInfo = {
      fileType: '',
      fileUrl: Host + url
    }
    var imgTest = /\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/
    var videoTest = /\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|ogg|mp4)$/
    if (imgTest.test(url)) {
      fileInfo.fileType = 'image'
    } else if (videoTest.test(url)) {
      fileInfo.fileType = 'video'
    }
    callback(fileInfo)
  },
  /**
   * @desc 删除数组中的某个字段
   * @param {*} array 数组
   * @param {*} val 某个字段
   */
  removeArrItem: function (array, val) {
    Array.prototype.indexOf = function (val) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] == val) return i;
      }
      return -1;
    };
    Array.prototype.remove = function (val) {
      var index = this.indexOf(val);
      if (index > -1) {
        this.splice(index, 1);
      }
    };
    array.remove(val);
    return array
  },



  //方法创建新对象
  // let Utils = Object.create(null)

  encode: function (_map, _content) {
    _content = '' + _content
    if (!_map || !_content) {
      return _content || ''
    }
    return _content.replace(_map.r, function ($1) {
      var _result = _map[!_map.i ? $1.toLowerCase() : $1]
      return _result != null ? _result : $1
    });
  },

  escape: (function () {
    let _reg = /<br\/?>$/
    let _map = {
      r: /\<|\>|\&|\r|\n|\s|\'|\"/g,
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      ' ': '&nbsp;',
      '"': '&quot;',
      "'": '&#39;',
      '\n': '<br/>',
      '\r': ''
    }
    return function (_content) {
      _content = util.encode(_map, _content)
      return _content.replace(_reg, '<br/>');
    };
  })(),

  object2query: function (obj) {
    let keys = Object.keys(obj)
    let queryArray = keys.map(item => {
      return `${item}=${encodeURIComponent(obj[item])}`
    })
    return queryArray.join('&')
  },

  // https://cn.vuejs.org/v2/guide/reactivity.html
  // Vue 不能检测到对象属性的添加或删除。然而它可以使用 Vue.set(object, key, value) 方法将响应属性添加到嵌套的对象上
  mergeObject: function (dest, src) {
    if (typeof dest !== 'object' || dest === null) {
      dest = Object.create(null)
    }
    dest = Object.assign(Object.create(null), dest, src)
    return dest
  },

  mergeVueObject: function (dest, src) {
    let keys = Object.keys(src)
    keys.forEach(item => {
      if (typeof src[item] !== 'undefined') {
        Vue.set(dest, item, src[item])
      }
    })
    return dest
  },

  // 消息类型列表
  mapMsgType: function (msg) {
    let map = {
      text: '文本消息',
      image: '图片消息',
      file: '文件消息',
      audio: '语音消息',
      video: '视频消息',
      geo: '地理位置消息',
      tip: '提醒消息',
      custom: '自定义消息',
      notification: '系统通知',
      robot: '机器人消息'
    }
    let type = msg.type
    return map[type] || '未知消息类型'
  },

  stringifyDate: function (datetime, simple = false) {
    // let weekMap = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    let weekMap = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    datetime = new Date(datetime)
    let year = datetime.getFullYear()
    let simpleYear = datetime.getYear() - 100
    let month = datetime.getMonth() + 1
    month = month > 9 ? month : '0' + month
    let day = datetime.getDate()
    day = day > 9 ? day : '0' + day
    let hour = datetime.getHours()
    hour = hour > 9 ? hour : '0' + hour
    let min = datetime.getMinutes()
    min = min > 9 ? min : '0' + min
    let week = datetime.getDay()
    week = weekMap[week]
    let thatDay = (new Date(year, month - 1, day, 0, 0, 0)).getTime()

    if (simple) {
      return {
        withYear: `${day}/${month}/${simpleYear}`,
        withMonth: `${month}-${day}`,
        withDay: `${week}`,
        withLastDay: `昨天`,
        withHour: `${hour}:${min}`,
        thatDay
      }
    } else {
      return {
        withYear: `${year}-${month}-${day} ${hour}:${min}`,
        withMonth: `${month}-${day} ${hour}:${min}`,
        withDay: `${week} ${hour}:${min}`,
        withLastDay: `昨天 ${hour}:${min}`,
        withHour: `${hour}:${min}`,
        thatDay
      }
    }
  },

  /* 格式化日期 */
  formatDate: function (datetime, simple = false) {
    let tempDate = (new Date()).getTime()
    let result = this.stringifyDate(datetime, simple)
    let thatDay = result.thatDay
    let deltaTime = (tempDate - thatDay) / 1000

    if (deltaTime < 3600 * 24) {
      return result.withHour
    } else if (deltaTime < 3600 * 24 * 2) {
      return result.withLastDay
    } else if (deltaTime < 3600 * 24 * 7) {
      return result.withDay
    } else if (deltaTime < 3600 * 24 * 30) {
      return result.withMonth
    } else {
      return result.withYear
    }
  },

  parseSession: function (sessionId) {
    if (/^p2p-/.test(sessionId)) {
      return {
        scene: 'p2p',
        to: sessionId.replace(/^p2p-/, '')
      }
    } else if (/^team-/.test(sessionId)) {
      return {
        scene: 'team',
        to: sessionId.replace(/^team-/, '')
      }
    }
  },

  parseCustomMsg: function (msg) {
    if (msg.type === 'custom') {
      try {
        let cnt = JSON.parse(msg.content)
        switch (cnt.type) {
          case 1:
            return '[猜拳消息]'
          case 2:
            return '[阅后即焚]'
          case 3:
            return '[贴图表情]'
          case 4:
            return '[白板消息]'
        }
      } catch (e) { }
      return '[自定义消息]'
    }
    return ''
  },
  /* 获得有效的备注名 */
  getFriendAlias: function (userInfo) {
    userInfo.alias = userInfo.alias ? userInfo.alias.trim() : ''
    return userInfo.alias || userInfo.nick || userInfo.account
  },

  generateChatroomSysMsg: function (data) {
    let text
    switch (data.attach.type) {
      case 'memberEnter':
        text = `欢迎${data.attach.fromNick}进入直播间`
        break
      case 'memberExit':
        text = `${data.attach.fromNick}离开了直播间`
        break
      case 'blackMember':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被管理员拉入黑名单`
        break
      case 'unblackMember':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被管理员解除拉黑`
        break
      case 'gagMember':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被管理员禁言`
        break
      case 'ungagMember':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被管理员解除禁言`
        break
      case 'addManager':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被任命管理员身份`
        break
      case 'removeManager':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被解除管理员身份`
        break;
      case 'addTempMute':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被管理员临时禁言`
        break;
      case 'removeTempMute':
        text = `${(data.attach.toNick[0] || data.attach.to[0])}被管理员解除临时禁言`
        break;
      case 'addCommon':
        text = `管理员添加普通成员`
        break
      case 'removeCommon':
        text = `管理员删除普通成员`
        break
      case 'kickMember':
        text = `${data.attach.toNick[0]}被管理员踢出房间`
        break;
      // case 'xxx':
      // 直播公告已更新
      // break;
      default:
        text = '通知消息'
        break
    }
    return text
  },

  generateTeamSysmMsg: function (data) {
    var text, nicks = this.getNickNames(data.attach.users)
    switch (data.attach.type) {
      case 'updateTeam':
        text = this.getTeamUpdateInfo(data)
        break;
      case 'addTeamMembers':
        {
          let op = nicks.pop()
          text = `${op}邀请${nicks.join()}加入群`
          break;
        }
      case 'removeTeamMembers':
        {
          let op = nicks.pop()
          text = `${nicks.join()}被${op}移出群`
          break;
        }
      case 'acceptTeamInvite':
        {
          let op = nicks.pop()
          text = `${nicks.join()}接受了${op}入群邀请`
          break;
        }
      case 'passTeamApply':
        {
          let op = nicks.shift()
          if (nicks.length === 1 && op === nicks[0]) {
            // 此情况为高级群设置不需要验证，用户申请入群后，收到的群消息提示
            text = `${op}加入群`
          } else {
            text = `${op}通过了${nicks}入群邀请`
          }
          break;
        }
      case 'addTeamManagers':
        {
          // todo test
          let op = nicks.pop()
          text = `${op}新增了${nicks}为管理员`
          break;
        }
      case 'removeTeamManagers':
        {
          // todo test
          let op = nicks.pop()
          text = `${op}移除了${nicks}的管理员权限`
          break;
        }
      case 'leaveTeam':
        {
          text = `${nicks.join()}退出了群`
          break;
        }
      case 'dismissTeam':
        {
          text = `${nicks.join()}解散了群`
          break;
        }
      case 'transferTeam':
        {
          // todo test
          let nicks = this.getNickNames(data.attach.users)
          let op = nicks.shift()
          text = `${op}转让群主给${nicks}`
          break;
        }
      case 'updateTeamMute':
        {
          let nicks = this.getNickNames(data.attach.users)
          let op = nicks.shift()
          text = `${nicks}被管理员${data.attach.mute ? '禁言' : '解除禁言'}`
          break;
        }
      default:
        break;
    }
    return text
  },

  // todo 写成私有成员方法
  getNickNames: function (users) {
    return users.map(user => {
      return user.account === store.state.userUID ? '你' : user.nick
    })
  },

  // todo 写成私有成员方法
  getTeamUpdateInfo: function (msg) {
    let text, team = msg.attach.team,
      op = this.getNickNames(msg.attach.users).pop()
    if (team['name']) {
      text = `${op}修改群名为${team['name']}`
    } else if (team['intro']) {
      text = `${op}修改群介绍为${team['intro']}`
    }
    // 由于群公告的交互与 Android iOS 不一致，现版本不适配群公告
    // else if (team['announcement']) {
    //   text = `${op}修改群公告为${team['announcement']}`
    // } 
    else if (team['joinMode']) {
      text = `群身份验证模式更新为${team.joinMode === 'noVerify' ? '不需要验证' : team.joinMode === 'needVerify' ? '需要验证' : '禁止任何人加入'}`
    } else if (team['inviteMode']) {
      text = `邀请他人权限为${team['inviteMode'] === 'all' ? '所有人' : '管理员'}`
    } else if (team['updateTeamMode']) {
      text = `群资料修改权限为${team['updateTeamMode'] === 'all' ? '所有人' : '管理员'}`
    } else if (team['beInviteMode']) {
      text = `被邀请人身份${team['beInviteMode'] === 'noVerify' ? '不需要验证' : '需要验证'}`
    } else {
      text = '更新群信息'
    }
    return text
  },

  teamConfigMap: {
    joinMode: {
      'noVerify': '不需要验证',
      'needVerify': '需要验证',
      'rejectAll': '禁止任何人加入'
    },
    beInviteMode: {
      'needVerify': '需要验证',
      'noVerify': '不需要验证'
    },
    inviteMode: {
      'manager': '管理员邀请',
      'all': '所有人邀请'
    },
    updateTeamMode: {
      'manager': '管理员修改',
      'all': '所有人修改'
    },
    memberType: {
      'manager': '管理员',
      'normal': '普通成员'
    }
  },
  validatenull: function (val) {
    if (typeof val === 'boolean') {
      return false
    }
    if (val instanceof Array) {
      if (val.length === 0) return true
    } else if (val instanceof Object) {
      if (JSON.stringify(val) === '{}') return true
    } else {
      if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') return true
      return false
    }
    return false
  },
  //图片字符串分割数组
  commentImgList (images) {
    if (images && images.indexOf(',') !== -1) {
      return images.split(',')
    } else {
      return [images]
    }
  },
  //相对路径改绝对路径
  getAabsolutePath(path) {
    if (path) {
      return process.env.VUE_APP_BASE_API + path
    }
  }
}

/**
 * 判断是否为空
 */
// export default {
// 	url,
// 	mergeJsonObject,
// 	paramHandle,
// 	clearStorage,
// 	removeStore,
// 	getStore,
// 	setStore,A
// 	getUserToken,
// 	getAccessToken,
// 	randomWord,
// 	Host,
// 	convertBase64UrlToBlob,
// 	getBase64Image,
// 	fileUrlHandle,
// 	dataURItoBlob,
// 	removeArrItem,
// 	validatenull
// };

export default util;